

// // src/utils/sessionHandler.js

// let sessionExpired = false;

// const originalFetch = window.fetch;

// window.fetch = async (...args) => {
//   try {
//     const response = await originalFetch(...args);

   

//     // Clone the response so the original response
//     // can still be used by your API function
//     const clonedResponse = response.clone();

//     try {
//       const data = await clonedResponse.json();

      

//       const message = data?.message?.toLowerCase() || '';

//       // Only trigger when message contains "token expired"
//       if (message.includes('token expired')) {
//         handleSessionExpired();
//       }

//     } catch (error) {
//       // Response is not JSON, so ignore it
//       console.log(error,'errrorinrepsonse')
//       console.log('Response is not JSON');
//     }

//     return response;

//   } catch (error) {
//     throw error;
//   }
// };

// const handleSessionExpired = () => {

//   // Prevent multiple API calls from triggering
//   // the session-expired page multiple times
//   if (sessionExpired) {
//     return;
//   }

//   sessionExpired = true;

 

//   // Save current page
//   if (window.location.pathname !== '/session-expired') {
//     sessionStorage.setItem(
//       'lastPageBeforeSessionExpired',
//       window.location.pathname
//     );
//   }

//   // Go to session expired page
//   window.location.href = '/session-expired';
// };

// export default {};



// src/utils/sessionHandler.js

let sessionExpired = false;

const originalFetch = window.fetch;

window.fetch = async (...args) => {
  try {
    const response = await originalFetch(...args);

    // Check whether the response is actually JSON
    const contentType = response.headers.get("content-type") || "";

    if (contentType.includes("application/json")) {
      try {
        const clonedResponse = response.clone();
        const data = await clonedResponse.json();

        const message = data?.message?.toLowerCase() || "";

        // Only trigger when message contains "token expired"
        if (message.includes("token expired")) {
          handleSessionExpired();
        }
      } catch (error) {
        console.error("❌ Failed to parse JSON response:", error);
      }
    }

    // Always return the original response
    return response;

  } catch (error) {
    throw error;
  }
};

const handleSessionExpired = () => {
  // Prevent multiple API calls from triggering
  // the session-expired page multiple times
  if (sessionExpired) {
    return;
  }

  sessionExpired = true;

  // Save current page
  if (window.location.pathname !== "/session-expired") {
    sessionStorage.setItem(
      "lastPageBeforeSessionExpired",
      window.location.pathname
    );
  }

  // Go to session expired page
  window.location.href = "/session-expired";
};

export default {};

